<div class="main-container">
  @if (isValidToken) {
    <div class="dashboard-container">
      <powerbi-dashboard
        [embedConfig]="dashboardConfig"
        cssClassName="dashboard-content"
        [eventHandlers]="eventHandlersMap"
        >
      </powerbi-dashboard>
    </div>
  }
  @if (exportDashboardService.isExportingInProgress$ | async) {
    <div
      style="margin: 10px"
      >
      <span class="exporting-status">Exporting dashboard...</span>
      <mat-spinner class="update-button-spinner" diameter="24" strokeWidth="2">
      </mat-spinner>
    </div>
  }
  @if (!isValidToken) {
    <div class="no-dashboard">
      <span> Sorry, there is no Power BI dashboard to show</span>
    </div>
  }
</div>
